<template>
    <button v-bind="$attrs" class="au-button">
        <div class="au-button__icon">
            <slot name="icon"></slot>
        </div>
        <div class="au-button__text">
            <div class="au-button__label">
                <label>
                    <slot name="label"></slot>
                    <slot name="default"></slot>
                </label>
            </div>
            <div class="au-button__sub-label">
                <label>
                    <slot name="sublabel"></slot>
                </label>
            </div>
        </div>
    </button>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.au-button {
    background: rgba(255, 255, 255, .35);
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    cursor: pointer;
    border: none;
    outline: none;
    pointer-events: all;
    color: white;
    font-family: Montserrat;
    padding: 10px;
}

.au-button__icon {
    margin-right: 20px;
    font-size: 24px;
}

.au-button__label {
    text-align: left;
    margin-bottom: 3px;
}

.au-button__sub-label {
    text-align: left;
    font-size: 10px;
    margin: 0;
    opacity: .8;
}
</style>